export enum DocumentsReasons {
  utilityBillRequirementFeedItem = 'utilityBillRequirementFeedItem',
  titleVerificationFeedItem = 'titleVerificationFeedItem',
}
export type DocumentsReason = (typeof documentsReasons)[number];
export const documentsReasons = Object.values(DocumentsReasons);

export enum DocumentAnalyticsEvent {
  updated = 'document task updated',
  completed = 'document task completed',
}
